<template>
  <div v-if="allLayersLoaded && $theMapObject.layers && profile">
    <v-list expand>
      <v-list-tile v-if="showSubheaders">
        <v-list-tile-content v-if="layers[0]">
          <v-list-tile-title style="width: auto">
            {{ layers[0].title }}
          </v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn
            fab
            small
            flat
            @click.stop="toggleTheme"
            label="Slå kartlag av/på"
            aria-label="Slå kartlag av/på"
          >
            <v-icon
              :color="profile.visible ? 'blue' : 'grey'"
              style="font-size: 20px;"
              >{{ profile.visible ? "mdi-eye" : "mdi-eye-off" }}</v-icon
            >
          </v-btn>
        </v-list-tile-action>

        <v-list-tile-action style="min-width: 35px">
          <layer-list-item-menu :item="profile" color="grey lighten-1" />
        </v-list-tile-action>
      </v-list-tile>
      <draggable
        :list="sublayers"
        :disabled="$vuetify.breakpoint.smAndDown"
        @change="reorder"
      >
        <div
          v-for="(sublayer, index) in sublayers.slice().reverse()"
          :key="index"
        >
          <layer-list-item-toc-sublayer
            :sublayer="sublayer"
            :parent-is-visible="profile.visible"
            :id="layer"
            :visibility="sublayer.visible"
            :key="index + 'sublayer'"
            @visible="onSublayerVisible"
          ></layer-list-item-toc-sublayer>
        </div>
      </draggable>
    </v-list>
  </div>
</template>

<script>
import LayerListItemTocSublayer from "@/pages/MapPage/Tools/Layers/LayerListItemTocSublayer";
import draggable from "vuedraggable";
import LayerListItemMenu from "@/pages/MapPage/Tools/Layers/LayerListItemMenu";
import Vue from "vue";
import MappingMixin from "@/mixins/mappingMixin";
import { mapActions } from "vuex";

export default {
  name: "LayerListItemToc",
  data: function() {
    return {
      allLayersLoaded: false,
      layers: [],
      sublayers: [],
      profile: null,
      layerListViewModel: null
    };
  },
  mixins: [MappingMixin],
  components: {
    LayerListItemTocSublayer,
    draggable,
    LayerListItemMenu
  },
  props: {
    layer: String,
    padding: Number,
    showSubheaders: Boolean
  },
  methods: {
    ...mapActions(["toggleProfileOpen"]),
    onSublayerVisible() {
      this.setMapLayerVisibility({
        profile: this.profile,
        visible: true
      });
    },
    toggleTheme() {
      this.setMapLayerVisibility({
        profile: this.profile,
        visible: !this.profile.visible
      });
    },
    toggleCollapse: function(evt) {
      Vue.set(evt, "collapsed", !evt.collapsed);
    },
    toggleSublayerVisibility: function(sublayer) {
      sublayer.visible = !sublayer.visible;
    },
    reorder(evt) {
      this.layers[0].sublayers.reorder(evt.moved.element, evt.moved.newIndex);
    },
    loadLayer() {
      this.allLayersLoaded = false;

      this.layers = [];
      this.profile = this.$store.getters["getAddedMapProfile"](this.layer);
      this.layers.push(this.$theMapObject.findLayerById(this.layer));

      let layer = this.$theMapObject.findLayerById(this.layer);
      if (layer && layer.hasOwnProperty("sublayers")) {
        this.sublayers = this.$theMapObject.findLayerById(
          this.layer
        ).sublayers.items;
      } else {
        this.sublayers = [];
      }

      this.allLayersLoaded = true;
    }
  },
  watch: {
    layer: function() {
      this.loadLayer();
    }
  },
  mounted() {
    this.loadLayer();
  }
};
</script>

<style scoped>
.toc {
  height: 100vh;
  width: 300px;
  padding: 10px;
  left: 0px;
  background: white;
  position: absolute;
  z-index: 10;
  top: 0px;
  height: 95%;
  overflow-y: scroll;
  overflow-x: none;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 0.6em 0;
  padding: 0;
}

.image-container {
  display: flex;
  flex-direction: column;
  margin-left: 7px;
  font-size: 14px;
}

.checkbox {
  margin-right: 5px;
}

.image {
  margin-left: 30px;
  margin-right: 6px;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */

.checkmark {
  position: absolute;
  top: 5px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #ccc;
}

/* On mouse-over, add a grey background color */

.checkbox-container:hover input ~ .checkmark {
  background-color: gray;
}

/* When the checkbox is checked, add a blue background */

.checkbox-container input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */

.checkbox-container .checkmark:after {
  left: 7px;
  top: 5px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.v-list__group__header__append-icon {
  display: none !important;
}
</style>
